import { request } from 'src/helpers/api';
import type { AxiosResponse } from 'axios';

type ApiResponse = Promise<AxiosResponse>;

export const getQuotes = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/quotes',
    params,
    cancel_token: 'getQuotes',
  })
);

export const getQuoteDetails = (quoteId: string | number): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/quotes/${quoteId}`,
  })
);

export const getQuotePdfLink = (quoteId: string | number): ApiResponse => (
  request({
    method: 'GET',
    url: `/api/quotes/${quoteId}/generate_pdf_link`,
  })
);

export const updateQuoteStatus = (
  quoteId: string | number,
  params: Record<string, unknown>,
): ApiResponse => (
  request({
    method: 'PUT',
    url: `/api/quotes/${quoteId}`,
    params,
  })
);

export const getQuotesCount = (params: Record<string, unknown>): ApiResponse => (
  request({
    method: 'GET',
    url: '/api/quote-list',
    params,
  })
);
